.outer-container {
  position: relative;
  display: grid;
  min-height: var(--chart-min-height, 15rem);
  max-height: var(--chart-max-height, 20rem);
  /* height: 10rem; */
  margin: var(--mantine-spacing-sm);
  container-type: inline-size;
  overflow: hidden;
  &.is-resizing {
    pointer-events: none;
    &::after {
      position: absolute;
      inset: 0.3rem;
      content: '';
      border: 0.1rem dashed var(--mantine-color-dark-4);
      border-radius: var(--mantine-radius-md);
    }
  }
}

/* TODO: container queries to specify ranges of min-heights for charts */

.inner-container {
  width: 100%;
  height: 100%;
}

.contents {
  display: grid;
  width: 100%;
  height: 100%;
}

.chart {
  width: 100%;
  height: 100%;
}

.heatmap {
  display: grid;
  align-self: center;
  justify-self: center;
}

@keyframes glow-pulse {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

.glow-pulse {
  animation: glow-pulse var(--pulse-speed, 2s) ease-in-out infinite;
}

.download-overlay {
  position: absolute;
  position-anchor: --grid-item;
  right: anchor(right);
  bottom: anchor(top);
  z-index: 1;
  opacity: 0;
  transition: opacity 150ms ease;
}

.outer-container:hover .download-overlay {
  opacity: 1;
}
